import React from 'react';
import {Card} from 'antd';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const ExpenseLineChart = ({data}) => {
    return (
        <Card title="Динамика расходов по месяцам">
            <ResponsiveContainer width="100%" height={350}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0"/>
                    <XAxis
                        dataKey="month"
                        tick={{fill: '#666'}}
                        axisLine={{stroke: '#d9d9d9'}}
                    />
                    <YAxis
                        tickFormatter={(value) => `${value.toLocaleString('ru-RU')} €`}
                        tick={{fill: '#666'}}
                        axisLine={{stroke: '#d9d9d9'}}
                    />
                    <Tooltip
                        formatter={(value) => [`${value.toLocaleString('ru-RU')} €`, '']}
                        labelFormatter={(label) => `Месяц: ${label}`}
                        contentStyle={{
                            backgroundColor: 'white',
                            border: '1px solid #d9d9d9',
                            borderRadius: '4px'
                        }}
                    />
                    <Legend/>
                    <Line
                        type="monotone"
                        dataKey="total"
                        stroke="#cf1322"
                        name="Всего расходов"
                        strokeWidth={3}
                        activeDot={{r: 6}}
                    />
                    <Line
                        type="monotone"
                        dataKey="salary"
                        stroke="#1890ff"
                        name="Зарплаты"
                        strokeWidth={2}
                    />
                    <Line
                        type="monotone"
                        dataKey="periodic_expenses"
                        stroke="#52c41a"
                        name="Периодические"
                        strokeWidth={2}
                    />
                    <Line
                        type="monotone"
                        dataKey="one_time_expenses"
                        stroke="#fa8c16"
                        name="Разовые"
                        strokeWidth={2}
                        strokeDasharray="5 5"
                    />
                </LineChart>
            </ResponsiveContainer>
        </Card>
    );
};

export default ExpenseLineChart;